import { Button, Inline, TextInput } from 'canoe';
import React, { useState } from 'react';
import styled from 'styled-components';
import { P, colors } from 'styleguide';

import { Video as VideoIcon } from 'craft/icons';

const PlaceHolderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2em;
  border-radius: 4px;
  border: 2px dashed ${colors('neutral', 5)};
`;

const InputRow = styled(Inline)`
  width: 300px;
  & > div:first-of-type {
    flex: 1;
  }
`;

interface Props {
  onSetVideoSource: (src: string) => void;
  failed: boolean;
}

const PlayerPlaceholder = ({ onSetVideoSource, failed }: Props) => {
  const [source, setSource] = useState('');
  return (
    <PlaceHolderWrapper>
      <VideoIcon width={34} height={34} />
      <P subtle textAlign="center" weight="bold" css={{ margin: 0 }}>
        Set Media Source
      </P>
      <P subtle textAlign="center">
        Link to YouTube, Vimeo, Soundcloud, etc...
      </P>
      <InputRow space="none" align="center">
        <TextInput
          grow
          scale="small"
          type="text"
          placeholder="https://"
          value={source}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSource(e.target.value)}
          data-craft-ignore-events
        />
        <Button ml="xs" size="small" onClick={() => onSetVideoSource(source)}>
          Add
        </Button>
      </InputRow>
      {failed ? (
        <P textAlign="center" color="red">
          Something went wrong playing this media source, maybe try another?
        </P>
      ) : null}
    </PlaceHolderWrapper>
  );
};

export default PlayerPlaceholder;
